
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import util from '@/utils/busi/util'
import { getMemberList, getMemberCount, resetPwd, resetOpenId } from '@/api/agentcenter'
import { MessageBox } from 'element-ui'
import { LocalStorage } from '@/utils/storage'
@Component({
  name: 'member-center',
  components: {
    SimpleTable
  }
})
export default class MemberCenter extends Vue {
  private form: any = {}

  private loading = !1

  private tableData: any = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'userAccount',
    label: '账号'
  },
  {
    prop: 'userName',
    label: '用户名称'
  },
  {
    prop: 'phone',
    label: '联系电话'
  },
  {
    prop: 'createTime',
    label: '注册时间',
    format: 'date'
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private pickerOptions = {
    shortcuts: [
      {
        text: '上一周',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近一个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近三个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          picker.$emit('pick', [start, end])
        }
      }
    ],
    disabledDate: !0,
    firstDayOfWeek: 7,
    cellClassName: () => 'custClass',
    onPick: null
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const temp = { ...this.form }
    if (temp.createTime) {
      temp.startDate = temp.createTime[0]
      temp.endDate = temp.createTime[1]
    }
    delete temp.createTime
    const form = util.trimForm({ ...temp }, ['userName', 'phone', 'startDate', 'endDate'])
    !pagination && (this.pagination.currentPage = 1)
    await getMemberList({
      ...form,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      this.loading = !1
      await getMemberCount({
        ...form
      }).then((resCnt: any) => {
        const userType = LocalStorage.getObj('user_info_key').userType
        if (userType === 3) {
          this.tableData.list = res.object.list.map((v: any) => {
            v.userAccount = v.userAccount ? v.userAccount.substring(0, 5) + '******' : ''
            v.userName = v.userAccount ? v.userName.substring(0, 5) + '******' : ''
            v.phone = v.userAccount ? v.phone.substring(0, 5) + '******' : ''
            return v
          })
        } else {
          this.tableData.list = res.object.list
        }
        this.tableData.totalCount = resCnt.object.totalCount
      })
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
    }
    this.onQuery()
  }

  private async onResetPwd () {
    // do
    if (!this.selectedRow || this.selectedRow.length === 0) {
      this.$alert('请选择账号')
      return
    }
    const ids = this.selectedRow.map((v: any) => v.id)
    const tbsUserIds = this.selectedRow.map((v: any) => v.tbsUserId)
    MessageBox.confirm(
      '提示：是否重置密码为888888', '密码重置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
      await resetPwd({
        tbsUserIds: tbsUserIds.join(','),
        ids: ids.join(',')
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message(res.message)
        }
      })
    })
  }

  private async onResetOpenId () {
    // do
    if (!this.selectedRow || this.selectedRow.length !== 1) {
      this.$alert('请选择单个账号')
      return
    }
    await resetOpenId({
      id: this.selectedRow[0].id
    }).then((res: any) => {
      if (res.code === 10000) {
        this.$message(res.message)
      }
    })
  }

  private selectedRow: any = []

  private selectionChange (selected: any) {
    this.selectedRow = selected
  }

  private showDetail (row: any) {
    row.onlyView = !0
    this.$router.push({
      name: 'memberdetail',
      params: row
    })
  }

  private updateUser (row: any) {
    row.onlyView = !0
    this.$router.push({
      name: 'memberupdate',
      params: row
    })
  }

  mounted () {
    this.onQuery()
  }
}
